<template>
  <div :class="classes">
    <pt-page-title title="意见反馈管理" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey"></pt-page-title>
    <pt-page-factor-filter :labels="orderTabLabels" v-model="params"  isQueryRouter ref="filter" @Filter="filter">
        <el-button type="primary" @click="filter()">筛选</el-button>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
    </pt-page-factor-filter>
    <pt-feedback-table :tableLabels="tableLabels" :params-data="paramsData" :isSearch="isSearch" ref="table" :isFromRouter="isFromRouter">
        <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="toDetail(scope.row)">详情</el-button>
            </template>
        </el-table-column>
    </pt-feedback-table>
  </div>
</template>

<script>
// 组件class前缀
import ptFeedbackTable from './pt-pt-feedback-table/withData'
import { orderTabLabels, tableLabels } from './feedback'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-feedback-manage'

export default {
  name: 'pt-feedback-manage',
  props: {
    newsCategories: {
      type: Array,
      default: function () {
        return []
      }
    },
    isTitle: {
      type: Boolean,
      default: true
    },
    tableParams: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptFeedbackTable
  },
  data () {
    return {
      params: {},
      orderTabLabels: orderTabLabels,
      tableLabels: tableLabels,
      paramsData: this.tableParams,
      isSearch: '',
      searchKey: '',
      isFromRouter: false
    }
  },
  methods: {
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      emptyObject(this.params)
      emptyObject(this.paramsData)
      this.paramsData.searchKey = val
      // this.isSearch = val
    },
    emptySearch (val) {
      this.$delete(this.searchKey, 'searchKey')
    },
    toDetail (val) {
      this.$router.push('/feedback-manage/pt-feedback-detail/' + val.id)
    },
    cleanParams () {
      emptyObject(this.params)
      this.filter()
    },
    filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (!isFromRouter) {
          this.searchKey = null
          if (this.params.searchKey) {
            this.$delete(this.params, 'searchKey')
          }
          this.$refs.filter.getAddRouter(this.params)
        }
        if (key === 'createdDate') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      this.paramsData = JSON.parse(JSON.stringify(this.params))
    //   this.paramsData = { ...this.params.createdDate, ...this.params }
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
